import { Route, Routes, Navigate } from 'react-router-dom';
import { AuthRoute } from '@omnigenbiodata/ui';
import ROUTES from '../core/constants/routes.constants';

import AuthScene from './AuthScene';
import Login from './AuthScene/scenes/Login';
import MultiFactor from './AuthScene/scenes/MultiFactor';
import NewPassword from './AuthScene/scenes/NewPassword';
import ResetPassword from './AuthScene/scenes/ResetPassword';
import SubmitResetPassword from './AuthScene/scenes/SubmitResetPassword';
import Logout from './AuthScene/scenes/Logout';
import HomeScene from './HomeScene';
import ParticipantInformationScene from './ParticipantInformationScene';
import PortalScene from './PortalScene';
import SampleScene from './PortalScene/scenes/SampleScene';
import ParticipantVideoScene from './ParticipantVideoScene';

function Scenes() {
  return (
    <Routes>
      <Route path={ROUTES.auth} element={<AuthScene />}>
        <Route path={ROUTES.auth} element={<Login />} />
        <Route path={ROUTES.authMfa} element={<MultiFactor />} />
        <Route path={ROUTES.authNewPassword} element={<NewPassword />} />
        <Route path={ROUTES.authResetPassword} element={<ResetPassword />} />
        <Route path={ROUTES.authSubmitResetPassword} element={<SubmitResetPassword />} />
        <Route path={ROUTES.authSignOut} element={<Logout />} />
      </Route>

      <Route path={ROUTES.root} element={<HomeScene />} />
      <Route path={ROUTES.info} element={<ParticipantInformationScene />} />
      <Route path={ROUTES.video} element={<ParticipantVideoScene />} />

      <Route path={ROUTES.portal} element={<AuthRoute path={ROUTES.portal} element={PortalScene} />}>
        <Route path={ROUTES.portal} element={<SampleScene />} />
      </Route>

      <Route path="*" element={<Navigate to={ROUTES.root} replace />} />
    </Routes>
  );
}

export default Scenes;
